export const JOIN_TEAM_NOTIFICATION_ID_KEY = '_fs_join_team_notif_id';
export const ACCEPT_JOIN_TEAM_PAYLOAD_KEY = '_fs_accept_join_team_payload';
